import {
  DeferralPenaltiesDocumentProps,
  DocumentProps,
} from '@/common/types/documents';

export enum StatusKeys {
  verifying = 'verifying',
  agreement = 'agreement',
  processing = 'processing',
}

export enum CabinetStatuses {
  registration_update = 'registration_update',
  application = 'application',
  info = 'info',
  sign = 'sign',
  deal = 'deal',
  prolongation = 'prolongation',
  repeat = 'repeat',
  blocking = 'blocking',
}

export interface PaymentScheduleProps {
  amount: string;
  date: string;
  payment_number: number;
  status: number;
}

export interface LoanDataProps {
  approved_amount: number;
  approved_period: number;
  date_given: string;
  date_repayment: string;
  request_amount: number;
  request_period: number;
  date_forced_schedule: string | null;
  agreement_id?: number;
  balance_total?: number;
  schedule?: PaymentScheduleProps[];
}

export enum AgreementDocumentType {
  agreement_insurance = 'agreement_insurance',
  agreement_obligations = 'agreement_obligations',
  policy = 'policy',
  restructurization_credit = 'restructurization_credit',
  restructurization_statement_credit = 'restructurization_statement_credit',
  statement_insurance_elderly = 'statement_insurance_elderly',
  statement_insurance_life = 'statement_insurance_life',
  'additional-agreement-by-address' = 'additional-agreement-by-address',
}

export type AgreementDocuments = Record<AgreementDocumentType, DocumentProps>;

export interface AgreementProps {
  additional_agreement: boolean;
  amount: {
    hand: number;
    insurance: number;
    main: number;
    prolongation: number;
    expenses: number;
  };
  calculation: {
    date: string;
    fine: number;
    insurance: number;
    main: number;
    overdue_days: number;
    prolongation: number;
    reward: number;
    total: number;
  };
  date: {
    closed: any;
    given: string;
    grace_end: string;
    prolongation: any;
    repayment: string;
  };
  documents: AgreementDocuments;
  close_status: boolean;
  hasParent: boolean;
  iban: string;
  id: number;
  iin: string;
  forced_prolongation: boolean;
  number: string;
  overdue_days: number;
  period: number;
  prolongation_available: boolean;
  standard_reward: number;
  status: number;
  status_label: string;
  uuid: string;
  can_pay_with_kaspi_qr: boolean;
  deferral_collection?: {
    amount?: number;
    documents?: DeferralPenaltiesDocumentProps[];
    status_text?: string;
  };
}

export interface CabinetDealProps {
  agreement?: AgreementProps;
}

export interface CabinetBlockingProps {
  expires?: string;
}

export interface CabinetRepeatProps {
  should_choose_type?: boolean;
  hasPreviouslyClosedAgreement?: boolean;
}

export interface CabinetRefinanceProps {
  agreement?: AgreementProps;
  amount_needed?: number;
  amount_paid?: number;
  amount_prolongation?: number;
  parent_agreement_id?: number;
}

export interface CabinetInfoProps {
  data?: LoanDataProps;
  key?: StatusKeys;
  message?: string;
  type?: string;
  status?: number;
  status_label?: string;
}

export interface CabinetRegistrationUpdateProps {
  iin: string;
}

export interface CabinetRestProps {
  promo_discount?: number;
  discount_reward?: number;
}
